export const validation = {
  client: {
    emails: {
      eachTypeSelected: 'Indiquez au moins une adresse e-mail pour chaque type d’e-mail',
      noEmptySelection: 'Sélectionnez au moins un type d’e-mail par adresse e-mail',
    },
  },
  dateFuture: 'Choisissez une date dans le futur.',
  dateSameOrAfter: '{{attribute}} doit tomber le {{after}} ou après.',
  dateTomorrow: 'La date d’échéance doit être au plus tôt demain.',
  email: {
    invalid: 'Saisissez une adresse e-mail valide.',
  },
  iban: 'Saisissez un numéro de compte valide.',
  integrations: {
    accountantEmailInvalid: 'Votre comptable n’a pas encore de compte sur notre plateforme Credit.',
  },
  invoice: {
    lines: {
      minimumOne: 'Ajoutez au moins une ligne de facture à la facture.',
      minimumOneNotFree: 'Ajoutez au moins une ligne de facture qui n’est pas gratuite.',
    },
  },
  invoiceTemplate: {
    nextInvoiceTomorrow: 'Votre prochaine facture peut être au plus tôt demain.',
  },
  max: '{{attribute}} ne peut pas être supérieur à {{max}}.',
  maxDiscount: 'La remise ne peut pas être supérieure au prix total.',
  maxFileSize: 'Le fichier ne peut pas dépasser {{max}} Mo.',
  maxLength: '{{attribute}} ne peut pas dépasser {{max}} caractères.',
  maxLengthInLanguage: '{{attribute}} ne peut pas dépasser {{max}} caractères ({{lang}}).',
  min: '{{attribute}} ne peut pas être inférieur à {{min}}.',
  minLength: '{{attribute}} doit contenir plus de {{min}} caractères.',
  password: {
    incorrect: 'Ce mot de passe est incorrect.',
    match: 'Ce mot de passe doit être identique au nouveau mot de passe.',
  },
  phoneNumber: {
    format: 'Saisissez un numéro de téléphone valide.',
    missingCallingCode: 'Le numéro de téléphone doit commencer par un indicatif de pays, par exemple +32 en Belgique.',
  },
  quotation: {
    lines: {
      minimumOne: 'Ajoutez au moins une ligne de devis au devis.',
      minimumOneNotFree: 'Ajoutez au moins une ligne de devis qui n’est pas gratuite.',
    },
  },
  required: 'Ce champ est obligatoire.',
  requiredAttribute: '{{attribute}} est obligatoire.',
  requiredInLanguage: 'Ce champ est obligatoire ({{lang}}).',
  vatNumber: {
    belgianFormat: 'Pouvez-vous saisir un numéro d’entreprise valide ? Il se compose de 10 chiffres et commence par 0 ou 1.',
    inactive: 'Cette organisation n’est pas active.',
    invalid: 'Le numéro de TVA n’est pas valide. Pouvez-vous le redemander ?',
    unique:
      'Vous avez déjà créé un client avec ce numéro de TVA. <0>Cliquez ici</0> pour ajouter une nouvelle personne de contact à ce client.',
  },
};
